<template>
  <v-app class="background-black">
   

    <v-content>
      <TableView/>
    </v-content>
  </v-app>
</template>
<style >
.background{
  background-color:#F8FDFB !important;
}
.background-black
{
  background-color: #272727 !important;
}
</style>
<script>
import TableView from './components/TableView';

export default {
  name: 'App',

  components: {
    TableView,
  },

  data: () => ({
    //
  }),
};
</script>
